const hasRun = localStorage.getItem('hasRunThisSessionAdd');
const hasRedirect = localStorage.getItem('hasRedirectThisSession');

function getCookie(name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts && parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
  return null;
}

function base64UrlDecode(base64Url) {
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  switch (base64.length % 4) {
    case 2:
      base64 += '==';
      break;
    case 3:
      base64 += '=';
      break;
  }
  return decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
}

function decodeJWT(token) {
  const [header, payload, signature] = token.split('.');
  const decodedHeader = JSON.parse(base64UrlDecode(header));
  const decodedPayload = JSON.parse(base64UrlDecode(payload));
  return { header: decodedHeader, payload: decodedPayload, signature };
}

function getCookieByPartName(partialName) {
  const cookies = document.cookie.split(';');

  // Loop through cookies
  for (let cookie of cookies) {
    cookie = cookie.trim(); // Remove any leading/trailing spaces
    if (cookie.includes('CognitoIdentityServiceProvider') && cookie.includes(partialName)) {
      // Return the cookie's value
      return cookie.split('=')[1];
    }
  }

  // If no match, return null
  return null;
}


const cookiex = getCookieByPartName('idToken');
const cookiey = getCookieByPartName('accessToken');

if (cookiex && cookiex.length && cookiey && cookiey.length && !hasRedirect) {
  let decodedJWT;
  if (cookiex && cookiex.length) {
    decodedJWT = decodeJWT(cookiex).payload;
  }

  if (!decodedJWT) {
    console.error('No valid cookie found');
  }

  if (window.shopSettings.environment !== 'prod') {
    console.log('decodedJWT:', decodedJWT);
  }

  const email = decodedJWT['email'] || null;
  const firstName = decodedJWT['given_name'] || null;
  const lastName = decodedJWT['family_name'] || null;
  const prsID = decodedJWT['custom:prs-id'] || null;
  const type = window.shopAll.site === "fender" ? "fender_shopify" : "shopify";
  const storeID = window.shopAll.region || null;
  const redirectUrl = window.location.href;
  const apiUrl = window.shopAll.cognitoTokenApiUrl || null;
  const token = cookiey || null;
  const payload = {
	  type: type,
    email: email,
    firstName: firstName,
    lastName: lastName,
    user_id: prsID,
    storeID: storeID,
    return_to: redirectUrl
  };

  if(token && token.length && apiUrl && apiUrl.length && payload && payload.storeID && payload.storeID.length && payload.email && payload.email.length) {
    
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'X-USER-TOKEN': token
      },
      body: JSON.stringify(payload)
    }).then(response => {
      return response.json();
    }).then(response => {
      if (window.shopSettings.environment !== 'prod') {
        console.log('Cognito token API response:', response);
      }
      if(response && response.token && response.token.length) {
        localStorage.setItem('hasRedirectThisSession', 'true');
        let redirectUrl = window.location.origin + '/account/login/multipass/' + response.token;
        window.location.href = redirectUrl;
      }
    });
  }
}
else if (hasRun) {
  document.cookie =
    'presonus-shop-session-idtoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
    window.location.hostname +
    '';
  document.cookie =
    'presonus-shop-session-accesstoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
    window.location.hostname +
    '';
  document.cookie =
    'presonus-shop-session-refreshtoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
    window.location.hostname +
    '';
  document.cookie =
    'fender-connect-auth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + window.location.hostname + '';
  document.cookie =
    'fender-connect-start=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + window.location.hostname + '';
  document.cookie =
    'fender-connect-user-properties=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
    window.location.hostname +
    '';
  document.cookie =
    'fender-connect-session-cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
    window.location.hostname +
    '';

  document.cookie.split(';').forEach(function(c) {
    if (c.trim().startsWith('CognitoIdentityServiceProvider')) {
      const name = c.split('=')[0].trim();
      document.cookie =
        name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + window.location.hostname + '';
    }
  });

  var parts = location.hostname.split('.');
  var sndleveldomain = parts.slice(-2).join('.');

  if (sndleveldomain && sndleveldomain.length) {
    document.cookie =
      'presonus-shop-session-idtoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
    document.cookie =
      'presonus-shop-session-accesstoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
      sndleveldomain + '';
    document.cookie =
      'presonus-shop-session-refreshtoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
      sndleveldomain +
      '';
    document.cookie =
      'fender-connect-auth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
    document.cookie =
      'fender-connect-start=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
    document.cookie =
      'fender-connect-user-properties=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
    document.cookie =
      'fender-connect-session-cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';

    document.cookie.split(';').forEach(function(c) {
      if (c.trim().startsWith('CognitoIdentityServiceProvider')) {
        const name = c.split('=')[0].trim();
        document.cookie =
          name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
      }
    });
  }

  const cartAttributes = {
    attributes: {
      request_url: '',
      jwt: '',
      fcID: '',
      prsID: '',
      customer_id: '',
      site: '',
      region: '',
      shopifyCustomerID: '',
      sub_exists: '',
      sub_status: '',
      legacy_sub: '',
      software_exists: '',
      software_upgrade: '',
      software_grace_period: '',
      has_play_sub: '',
      has_studio_pro: ''
    }
  };

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(cartAttributes)
  }).then(response => {
    localStorage.removeItem('hasRunThisSessionAdd');
    localStorage.removeItem('hasRunThisSessionSubs');
    localStorage.removeItem('hasRunThisSessionSoftware');
    localStorage.removeItem('hasReload');
    localStorage.removeItem('fcID');
    localStorage.removeItem('prsID');
    localStorage.removeItem('email');
    localStorage.removeItem('firstName');
    localStorage.removeItem('lastName');
    localStorage.removeItem('token');
    localStorage.removeItem('hasRedirectThisSession');
  });
}
